import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Search, Plus, BarChart3, User, Trophy } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t, language } = useTranslation();
  const { isDark } = useTheme();

  // Fonction pour naviguer et scroller en haut
  const handleNavigation = (path) => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    navigate(path);
  };

  const getNavItems = () => [
    { icon: Home, labelKey: 'home.hello', label: language === 'fr' ? 'Accueil' : 'Home', path: '/', testId: 'nav-home' },
    { icon: Search, labelKey: 'matches.title', label: language === 'fr' ? 'Matchs' : 'Matches', path: '/matches', testId: 'nav-matches' },
    { icon: Plus, labelKey: 'matches.create', label: language === 'fr' ? 'Créer' : 'Create', path: '/matches/create', testId: 'nav-create', isCenter: true },
    { icon: Trophy, labelKey: 'tournaments.title', label: language === 'fr' ? 'Tournois' : 'Tournaments', path: '/tournaments', testId: 'nav-tournaments' },
    { icon: User, labelKey: 'profile.title', label: language === 'fr' ? 'Profil' : 'Profile', path: '/profile', testId: 'nav-profile' },
  ];

  const navItems = getNavItems();

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl border-t transition-colors duration-300 ${
      isDark 
        ? 'bg-[#0d1829]/90 border-white/10' 
        : 'bg-white/90 border-gray-200'
    }`}>
      <div className="max-w-md mx-auto flex items-center justify-around px-4 py-3">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          if (item.isCenter) {
            return (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                data-testid={item.testId}
                className={`w-14 h-14 -mt-6 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 ${
                  isDark 
                    ? 'bg-gradient-to-r from-[#00d4ff] to-[#00b8d4] hover:shadow-[#00d4ff]/50' 
                    : 'bg-gradient-to-r from-[#0891b2] to-[#0e7490] hover:shadow-[#0891b2]/50'
                }`}
              >
                <Icon size={28} strokeWidth={2.5} className="theme-text" />
              </button>
            );
          }

          return (
            <button
              key={item.path}
              onClick={() => handleNavigation(item.path)}
              data-testid={item.testId}
              className="flex flex-col items-center gap-1 transition-colors duration-200"
            >
              <Icon
                size={24}
                className={isActive 
                  ? (isDark ? 'theme-accent' : 'text-[#0891b2]')
                  : (isDark ? 'text-zinc-400' : 'text-gray-500')
                }
              />
              <span
                className={`text-[10px] font-medium ${
                  isActive 
                    ? (isDark ? 'theme-accent' : 'text-[#0891b2]')
                    : (isDark ? 'text-zinc-400' : 'text-gray-500')
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;
